
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"workspaceAutocompleteUsersSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fullPath"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isProject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"groupNamespace"},"name":{"kind":"Name","value":"group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fullPath"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fullPath"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isProject"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"autocompleteUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compositeIdentityEnforced"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gl_introduced"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"StringValue","value":"18.7.0","block":false}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"User"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvailability"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutocompleteUserStatus"},"directives":[]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"namespace"},"name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fullPath"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fullPath"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"autocompleteUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compositeIdentityEnforced"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gl_introduced"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"StringValue","value":"18.7.0","block":false}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"User"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvailability"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutocompleteUserStatus"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":836}};
    doc.loc.source = {"body":"#import \"../fragments/user.fragment.graphql\"\n#import \"~/graphql_shared/fragments/user_availability.fragment.graphql\"\n#import \"ee_else_ce/graphql_shared/fragments/user_autocomplete_status.fragment.graphql\"\n\nquery workspaceAutocompleteUsersSearch(\n  $search: String!\n  $fullPath: ID!\n  $isProject: Boolean = true\n) {\n  groupNamespace: group(fullPath: $fullPath) @skip(if: $isProject) {\n    id\n    users: autocompleteUsers(search: $search) {\n      compositeIdentityEnforced @gl_introduced(version: \"18.7.0\")\n      ...User\n      ...UserAvailability\n      ...AutocompleteUserStatus\n    }\n  }\n  namespace: project(fullPath: $fullPath) {\n    id\n    users: autocompleteUsers(search: $search) {\n      compositeIdentityEnforced @gl_introduced(version: \"18.7.0\")\n      ...User\n      ...UserAvailability\n      ...AutocompleteUserStatus\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/user.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql_shared/fragments/user_availability.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("ee_else_ce/graphql_shared/fragments/user_autocomplete_status.fragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["workspaceAutocompleteUsersSearch"] = oneQuery(doc, "workspaceAutocompleteUsersSearch");
        
